import React, { PureComponent } from 'react'
import { Helmet } from 'react-helmet'
// import { Link } from 'react-router-dom'
import { connect } from 'react-redux'

@connect(({ user }) => ({ user }))
export default class Index extends PureComponent {
  signOut = () => {
    const { dispatch } = this.props
    dispatch({
      type: 'user/SIGNOUT',
    })
  }

  render() {
    return (
      <div className="cm-error-page">
        <Helmet title="Not Authorized" />
        <div className="cm-ep-box">
          <h1 className="font-size-36 mb-2">Not Authorized</h1>
          <p className="mb-3 text-black-50">You are not authorized to view this page</p>
          <h1 className="font-size-80 mb-4 font-weight-bold">403 —</h1>
          <button type="button" onClick={this.signOut} className="btn">
            &larr; Go back to login page
          </button>
        </div>
      </div>
    )
  }
}
